export default function Close() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.9352 12.2315L12.0648 20.1019" stroke="white" strokeWidth="2" />
      <path d="M12.0648 12.2315L19.9352 20.1019" stroke="white" strokeWidth="2" />
      <path
        d="M2.36459 16C2.36459 8.46938 8.46937 2.36459 16 2.36459C23.5307 2.36459 29.6355 8.46938 29.6355 16C29.6355 23.5307 23.5307 29.6355 16 29.6355C8.46937 29.6355 2.36459 23.5307 2.36459 16Z"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
}
